import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync } from '@angular/router';
import { AuthorizationService } from '~ngx-shared/authentication';
import { AuthorizationUtil } from '~shared/utils';

@Injectable({ providedIn: 'root' })
export class CanAccessTeacherFormGuard implements CanActivate {
  private readonly authorizationService = inject(AuthorizationService);

  canActivate(route: ActivatedRouteSnapshot): MaybeAsync<GuardResult> {
    const personId = route.paramMap.get('person-id');
    if (personId === 'new') {
      return this.authorizationService.can(AuthorizationUtil.GROUP_TEACHER_MANAGEMENT);
    }
    return true;
  }
}
